export default {
  webBaseURL: process.env.MIX_APP_URL
}
